import { render, staticRenderFns } from "./ProductArtworksModal.vue?vue&type=template&id=7ac3383f&scoped=true&"
import script from "./ProductArtworksModal.vue?vue&type=script&lang=js&"
export * from "./ProductArtworksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac3383f",
  null
  
)

export default component.exports